import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-folder-layout',
  templateUrl: './folder-layout.component.html',
  styleUrls: ['./folder-layout.component.less']
})
export class FolderLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
